module.exports = __webpack_public_path__ + "img/img_liucheng.52940676.jpg";